(function () {
  'use strict';
  /**
   * TODO navegacion de dias (30, 100, temporada)
   */

  angular
      .module('irricrops')
      .controller('vinedoSeguimientoIrriviewCtrl', vinedoSeguimientoCtrl);

  vinedoSeguimientoCtrl.$inject = ['vinedo', 'global', 'menu', '$stateParams', 'cuartelDialog', '$q',
    'seguimientoRes', 'temporadaFac', 'Config', 'MultiChart','urls', '$http', '$scope'];

  /* @ngInject */
  function vinedoSeguimientoCtrl(vinedo, global, menu, $stateParams, cuartelDialog, $q, 
                                 seguimientoRes, temporadaFac, Config, MultiChart, urls, $http, $scope) {

    var vm               = this;
    var vinedoId         = $stateParams.id;
    var lastDataGrafico = null;
    vm.vinedo            = vinedo.data;
    vm.temporadas        = [];
    vm.alertEmptySelect = false;
    vm.volumenTotal = 0;
    vm.volumenTotalHA = 0;
    vm.fechaInicioGradosDia_m = null; 
    vm.temporadaSelected = {
      periodo: null
    };
    vm.loadingGeneral    = true;
    vm.irriviewApi = {};

    vm.chart             = {
      loadingChart : true,
      chartConfig  : null
    };

    var PERIODO_FENOLOGIA = {
      nombre : "Periodos",
      enabled: true
    };
    var PERIODO_MESES     = {
      nombre : "Meses",
      enabled: true
    };
    var PERIODO_SEMANAS   = {
      nombre : "Semanas",
      enabled: true
    };
    var PERIODO_DIAS   = {
      nombre : "Dias",
      enabled: true
    };

    vm.PERIODO_FENOLOGIA = PERIODO_FENOLOGIA;
    vm.PERIODO_MESES     = PERIODO_MESES;
    vm.PERIODO_SEMANAS   = PERIODO_SEMANAS;
    vm.PERIODO_DIAS      = PERIODO_DIAS;

    vm.periodos = [
      PERIODO_FENOLOGIA,
      PERIODO_MESES,
      PERIODO_SEMANAS,
      PERIODO_DIAS
    ];

    vm.periodoSelected = PERIODO_FENOLOGIA;

    vm.cantidadSemanasArray = [
      {
        num: 5,
        label: "5 Semanas"
      },
      {
        num: 10,
        label: "10 Semanas"
      },
      {
        num: 20,
        label: "20 Semanas"
      }
    ];

    vm.cantidadDiasArray = [
      {
        num: 20,
        label: "20 Dias"
      },
      {
        num: 40,
        label: "40 Dias"
      },
      {
        num: 60,
        label: "60 Dias"
      }
    ];

    vm.cantidadSemanasSelected  = vm.cantidadSemanasArray[0];
    vm.cantidadDiasSelected = vm.cantidadDiasArray[0];

    vm.dateSelected = new Date();
    vm.inicioSemana = moment(vm.dateSelected).subtract(vm.cantidadSemanasSelected.num-1, "week").startOf('week').isoWeekday(1).format("DD/MM/YYYY");
    vm.finSemana = moment(vm.dateSelected).endOf('week').format("DD/MM/YYYY");

    vm.inicioDias = moment(vm.dateSelected).subtract(vm.cantidadDiasSelected.num-1, "days").format("DD/MM/YYYY");
    vm.finDias = moment(vm.dateSelected).format("DD/MM/YYYY");



    menu.getSidebarProm().then(function(){
      vm.equipos = global.getSidebarData(vinedoId).equipos;
    });



    vm.dataHttp = {
      vinedo_id: vinedoId,
      periodo: vm.temporadaSelected.periodo
    };

    vm.showDialogSector = function(ev, sector) {
      cuartelDialog.showDialog(ev, sector.id);
    }

    vm.getDatosDias = function (dataHttp) {
      dataHttp.dias = vm.cantidadDiasSelected.num;
      dataHttp.fecha = moment(vm.dateSelected).format("DD-MM-YYYY");

      vm.inicioDias = moment(vm.dateSelected).subtract(vm.cantidadDiasSelected.num-1, "days").format("DD/MM/YYYY");
      vm.finDias = moment(vm.dateSelected).format("DD/MM/YYYY");

      var p = seguimientoRes.dias(dataHttp).$promise;
      p.then(function(res){
        vm.graficar(res.data.datos);
        vm.volumenTotal = res.data.total.volumen_total;
        vm.volumenTotalHA = res.data.total.volumen_ha;
        vm.loadingGeneral = false;
      });
    };

    vm.getDatosSemanas = function (dataHttp) {
      dataHttp.semanas = vm.cantidadSemanasSelected.num;
      dataHttp.fecha = moment(vm.dateSelected).format("DD-MM-YYYY");

      vm.inicioSemana = moment(vm.dateSelected).subtract(vm.cantidadSemanasSelected.num-1, "week").startOf('week').isoWeekday(1).format("DD/MM/YYYY");
      vm.finSemana = moment(vm.dateSelected).endOf('week').format("DD/MM/YYYY");


      var p = seguimientoRes.semanas(dataHttp).$promise;
      p.then(function(res){
        vm.graficar(res.data.datos);
        vm.volumenTotal = res.data.total.volumen_total;
        vm.volumenTotalHA = res.data.total.volumen_ha;
        vm.loadingGeneral = false;
      });
    };

    vm.getDatosMeses = function (dataHttp) {
      var p = seguimientoRes.meses(dataHttp).$promise;

      p.then(function(res){
        vm.graficar(res.data.datos);
        vm.volumenTotal = res.data.total.volumen_total;
        vm.volumenTotalHA = res.data.total.volumen_ha;
        vm.loadingGeneral = false;
      });
    };

    vm.getDatosFenologia = function (dataHttp) {
      //'?vinedo_id=61&sectores_riego_id[0]=1417&sectores_riego_id[1]=1418&sectores_riego_id[2]=1419")
      var p = seguimientoRes.fenologia(dataHttp).$promise;

      p.then(function(res){
        if(res.data.datos.length > 0){
          vm.graficar(res.data.datos);
          vm.volumenTotal = res.data.total.volumen_total;
        vm.volumenTotalHA = res.data.total.volumen_ha;
          vm.loadingGeneral = false;
        }else{
          vm.selectPeriodo(PERIODO_MESES);
          PERIODO_FENOLOGIA.enabled = false;
        }
      });
    };

    var concatLabelsData = function(labelsData, aditionalData){
      var labelsDataCopy = angular.copy(labelsData);
      _.each(labelsDataCopy, function(ld, index){
        //XXX lb label data, sin concatenar
        var prefix = "+";
        var c = "#43a047"// green
        if(aditionalData[index] < 0){
          prefix = "";
          c = "#d32f2f" // red
        }
        labelsDataCopy[index] = "<span style='color:"+c+"'>"+prefix + 
          _.round(aditionalData[index])+
          "%</span>";
      });
      return labelsDataCopy;
    }


    vm.selectPeriodo = function (periodo) {
      vm.periodoSelected = periodo;
      vm.loadingGeneral = true;
      var dataHttp = angular.copy(vm.dataHttp);
      switch (periodo){
        case PERIODO_FENOLOGIA:
          vm.getDatosFenologia(dataHttp);
          break;
        case PERIODO_MESES:
          vm.getDatosMeses(dataHttp);
          break;
        case PERIODO_SEMANAS:
          vm.getDatosSemanas(dataHttp);
          break;
        case PERIODO_DIAS:
          vm.getDatosDias(dataHttp);
          break;
        default:
          console.error("item no encontrado");
          vm.loadingGeneral = false;
      }
    };

    vm.selectSectoresCallback = function(dialogData){
      vm.sectoresSeleccionados = dialogData.seleccionados;
      if(dialogData === undefined){
        return false;
        console.error("dialogData undefined");
      }
      vm.alertEmptySelect = false;
      if(dialogData.seleccionados.length == 0){
        vm.alertEmptySelect = true;
        return false;
      }
      if(dialogData.all === false){
        vm.dataHttp["sectores_riego_id[]"] = dialogData.seleccionadosIds;
      }else{
        delete vm.dataHttp["sectores_riego_id[]"];
      }
      vm.selectPeriodo(vm.periodoSelected);
    };

    vm.changeSemanas = function () {
      vm.selectPeriodo(vm.periodoSelected);
    };

    vm.changeDias = function () {
      vm.selectPeriodo(vm.periodoSelected);
    };

    vm.changeTemporada = function (temporada) {
      vm.dataHttp.periodo = vm.temporadaSelected.periodo;
      vm.selectPeriodo(vm.periodoSelected);
    };





    var hideBackdropCallback   = null;
    vm.showedBackdrop = false;
    vm.showPopoverDate = false;
    vm.dateSelected = new Date();

    vm.showBackdrop = function(fn) {
      if (fn !== undefined && fn !== null) {
        hideBackdropCallback = fn;
      }
      vm.showedBackdrop = true;
    };

    vm.hideBackdrop = function() {
      if (hideBackdropCallback !== null) {
        hideBackdropCallback();
        hideBackdropCallback = null;
      }
      vm.showedBackdrop = false;
    };


    vm.showSelectDate = function() {
      vm.showPopoverDate = true;
      vm.showBackdrop(function() {
        vm.showPopoverDate = false;
      });
    };

    vm.cancelSelectDate = function() {
      vm.showPopoverDate = false;
    };

    vm.dateToToday = function() {
      vm.dateSelected = new moment().set('minute', 0).set('second', 0).toDate().cleanHour();
    };

    $scope.$watch(function() {
      return vm.dateSelected;
    }, function(n, o) {
      if (n != o) {
        vm.hideBackdrop();
        vm.selectPeriodo(vm.periodoSelected);
      }
    });

    vm.atras = function(){
      switch (vm.periodoSelected){
        case PERIODO_DIAS:
          vm.atrasDias();
          break;
        case PERIODO_SEMANAS:
          vm.atrasSemanas();
          break;
        default:
          console.error("atras null");
      }
    };


    vm.adelante = function(){
      switch (vm.periodoSelected){
        case PERIODO_DIAS:
          vm.adelanteDias();
          break;
        case PERIODO_SEMANAS:
          vm.adelanteSemanas();
          break;
        default:
          console.error("atras null");
      }
    };

    vm.atrasSemanas = function(){
      vm.dateSelected = moment(vm.dateSelected).subtract(vm.cantidadSemanasSelected.num, "weeks").toDate();
      vm.selectPeriodo(PERIODO_SEMANAS);
    };

    vm.adelanteSemanas = function(){
      vm.dateSelected = moment(vm.dateSelected).add(vm.cantidadSemanasSelected.num, "weeks").toDate();
      vm.selectPeriodo(PERIODO_SEMANAS);
    };


    vm.atrasDias = function(){
      vm.dateSelected = moment(vm.dateSelected).subtract(vm.cantidadDiasSelected.num, "days").toDate();
      vm.selectPeriodo(PERIODO_DIAS);
    };

    vm.adelanteDias = function(){
      vm.dateSelected = moment(vm.dateSelected).add(vm.cantidadDiasSelected.num, "days").toDate();
      vm.selectPeriodo(PERIODO_DIAS);
    };


    vm.changeDateGD = function(){
      //vm.fechaInicioGradosDia_m = fecha
      vm.recalcularGradosDias();
      vm.graficar();
    }






    vm.recalcularGradosDias = function(a){
      vm.gradosDiasAcumulados = [];
      var fechaInicio = moment(vm.fechaInicioGradosDia_m);
      _.each(vm.dataGradosDias, function(gdObj){
        var d = [];// grados dias acumulados
        var aux = 0; //sumador
        var periodo = gdObj.periodo;
        _.each(gdObj.data, function(gd){
          var m = moment(gd.fecha);
          if(m.isAfter(fechaInicio)){
            aux += gd.grado_dia;
          }
          d.push([gd.fecha,_.round(aux, 2)]);
        });
        vm.gradosDiasAcumulados.push({
          periodo: periodo,
          data: d
        });
        fechaInicio.subtract(1, "year");
      });
    }

    vm.getGradosDiasGrafico = function(dates, a){
      //dates --> moment array
      var resArray = [];
      _.each(vm.gradosDiasAcumulados, function(gdObj){
        var res = {
          periodo: gdObj.periodo,
          data:[],
          labelsData:[]
        };
        _.each(gdObj.data, function(gd){
          _.each(dates, function(date){
            var m = moment(gd[0]);
            //if(m.isSame(date.date, "day")){ 
              if(m.date() == date.date.date() && 
              m.month() == date.date.month()){
                res.data.push([date.name , gd[1]]);
                res.labelsData.push(gd[1]);
              }
            //}
          });
        });
        resArray.push(res);
      });
      return resArray;
    }










    //---------------------------------------------------------------------------
    //---------------------------------------------------------------------------
    //---------------------------------------------------------------------------








    //si todos los datos son null
    //mchart se encarga de no agregarlo a los legend
    var params = [
      {
        label: "eto",
        nombre:"Et0",
        zero: null,
        default: null,
        round: 2,
      },
      {
        label: "etb",
        nombre:"Etb",
        zero: null,
        default: null,
        round: 2,
      },
      {
        label: "coeficiente",
        nombre:"coeficiente",
        zero: null,
        default: null,
        round: 2,
      },
      {
        label: "x_eto",
        nombre:"Et0 promedio",
        zero: null,
        default: null,
        round: 2,
      },
      {
        label: "x_etb",
        nombre:"Etb promedio",
        zero: null,
        default: null,
        round: 2,
      },
      {
        label: "reposicion_ideal",
        nombre:"Reposición Ideal",
        zero:null,
        default: null,
        round: 1,
      },
      {
        label: "reposicion_eto",
        nombre:"Reposición Et0",
        zero:null,
        default: null,
        round: 1,
      },
      {
        label: "reposicion_etb",
        nombre:"Reposicion Etb",
        zero:null,
        default: null,
        round: 1,
      },
      {
        label: "riego_real",
        nombre:"Riego Real",
        zero: null,
        default: null
      },
      {
        label: "riego_teorico_eto",
        nombre:"Riego Teorico Eto",
        zero: null,
        default: null,
        round: 0,
      },
      {
        label: "riego_teorico_etb",
        nombre:"Riego Teorico Etb",
        zero: null,
        default: null,
        round: 0,
      },
      {
        label: "volumen_dif_eto",
        nombre:"---",
        zero: null,
        default: null,
        round: 0,
      },
      {
        label: "volumen_dif_etb",
        nombre:"---",
        zero: null,
        default: null,
        round: 0,
      },
      {
        label: "volumen_total",
        nombre:"Volumen total",
        zero: null,
        default: null,
        round: 0,
      },
      {
        label: "volumen_ha",
        nombre:"Volumen/ha",
        zero: null,
        default: null,
        round: 0,
      },
      {
        label: "volumen_ha_teorico_etb",
        nombre:"Volumen/ha teórico etb",
        zero: null,
        default: null,
        round: 0,
      },
      {
        label: "volumen_ha_teorico_eto",
        nombre:"Volumen/ha teórico et0",
        zero: null,
        default: null,
        round: 0,
      },
      {
        label: "scholander",
        nombre:"Scholander",
        zero: null,
        default: null,
        round: 1,
      }
    ]


    vm.graficar = function (data) {

      if(data !== undefined){
        lastDataGrafico = data;
      }else{
        var data = lastDataGrafico;
      }

      /*
      var mchartRiego      = new MultiChart("Seguimiento de Riegos");
      var mchartReposicion = new MultiChart("Seguimiento de Reposición");
      var mchartEt         = new MultiChart("Seguimiento de Evapotranspiración");
      var mchartVol        = new MultiChart("Seguimiento de Volumen y Scholander");
      var mchartGD         = new MultiChart("Seguimiento de Indice de Winkler");

      mchartRiego.deletePositioner();
      mchartReposicion.deletePositioner();
      mchartEt.deletePositioner();
      mchartVol.deletePositioner();
      mchartGD.deletePositioner();

      mchartRiego.xAxisRotation(0);
      mchartReposicion.xAxisRotation(0);
      mchartEt.xAxisRotation(0);
      mchartVol.xAxisRotation(0);
      mchartGD.xAxisRotation(0);
      */

      var chartRiego = {title: "Riego", items:[]};
      var chartReposicion = {title: "Reposición", items:[]};
      var chartCrecimiento = {title: "Crecimiento", items:[]};
      var chartClima = {title: "Datos Climaticos", items:[]};


      var dataParams = {};
      var dataLabels = {};

      _.each(params, function(param){
        dataParams[param.label] = [];
        dataLabels[param.label] = [];
      });

      dataParams["volumen_ha_acum"] = [];
      dataLabels["volumen_ha_acum"] = [];
      var val = 0 ;

      _.each(data, function(item, index){
        var l = item.nombre;
        if(vm.periodoSelected == PERIODO_DIAS){
          l = moment(item.fecha).format("D [de] MMM");
        }
        if(vm.periodoSelected == PERIODO_SEMANAS){
          l = "S. "+moment(item.fecha_inicio).format("D [de] MMM, YYYY")
        }
        val = val + item.volumen_ha;
        dataParams["volumen_ha_acum"].push([l, _.round(val, 1)]);
        if(data.length - 1 == index){
          dataLabels["volumen_ha_acum"].push(_.round(val, 1));
        }else{
          dataLabels["volumen_ha_acum"].push("");
        }
      });

      var datesGradosDia = [];
      _.each(data, function(item){

        //nombre para eje X
        var l = item.nombre;
        if(vm.periodoSelected == PERIODO_DIAS){
          l = moment(item.fecha).format("D [de] MMM");
        }
        if(vm.periodoSelected == PERIODO_SEMANAS){
          l = "S. "+moment(item.fecha_inicio).format("D [de] MMM, YYYY")
        }


        //el primer dato para grados dias, inicio de "..."
        /*
        if(datesGradosDia.length == 0 && vm.periodoSelected !== PERIODO_DIAS){
          var dateGd = moment(item.fecha_inicio);
          datesGradosDia.push({
            name: "Inicio "+l,
            date: dateGd
          });
        }
        */


        //datos para grados dias (nombre eje x , fecha_fin)
        var dateGd = moment(item.fecha_fin);
        if(vm.periodoSelected == PERIODO_DIAS){
          dateGd = moment(item.fecha);
        }
        datesGradosDia.push({
          name: l,
          date: dateGd
        });


        _.each(params, function(param){
          if(item[param.label] == null){
            dataParams[param.label].push(
              [l, param.default]
            );
            dataLabels[param.label].push(param.default);
          }else if(item[param.label] == 0){
            dataParams[param.label].push(
              [l, param.zero]
            );
            dataLabels[param.label].push(param.zero);
          }else{
            dataParams[param.label].push(
              [l, item[param.label]] //REAL
            );
            dataLabels[param.label].push(_.round(item[param.label], param.round));
          }
        });
      });

      /*
      mchartRiego.agregarSerie({
        color        : Config.colors.riegoReal.background,
        name         : 'Riego Real',
        yAxis        : 2,
        type         : 'column',
        data         : dataParams.riego_real,
        labelsData   : dataLabels.riego_real,
        suffix       : ' mm',
        required     : true,
        visibleAxis  : true,
      });*/

      chartRiego.items.push({
        color        : Config.colors.riegoReal.background,
        name         : 'Riego Real',
        type         : 'column',
        data         : dataParams.riego_real,
        labelsData   : dataLabels.riego_real,
        suffix       : " mm"
      });

      /*
      mchartRiego.agregarSerie({
        color       : Config.colors.etb.background,
        name        : 'Riego teorica Etb',
        yAxis       : 2,
        type        : 'column',
        data        : dataParams.riego_teorico_etb,
        labelsData  : dataLabels.riego_teorico_etb,
        suffix      : ' mm',
        required    : true,
        visibleAxis : true,
        visible: Config.vinedo['estacionMet'] ? false : true
      });
      */

      chartRiego.items.push({
        color       : Config.colors.etb.background,
        name        : 'Riego teorica Etb',
        type        : 'column',
        data        : dataParams.riego_teorico_etb,
        labelsData  : dataLabels.riego_teorico_etb,
        suffix      : ' mm',
        visible: Config.vinedo['estacionMet'] ? false : true
      });

      /*
      mchartRiego.agregarSerie({
        color       : Config.colors.et0.background,
        name        : 'Riego teórica Eto',
        yAxis       : 2,
        type        : 'column',
        data        : dataParams.riego_teorico_eto,
        labelsData  : dataLabels.riego_teorico_eto,
        suffix      : ' mm',
        required    : true,
        visibleAxis : true,
        visible: Config.vinedo['estacionMet'] ? true : false
      });
      */

      chartRiego.items.push({
        color       : Config.colors.et0.background,
        name        : 'Riego teórica Eto',
        type        : 'column',
        data        : dataParams.riego_teorico_eto,
        labelsData  : dataLabels.riego_teorico_eto,
        suffix      : ' mm',
        visible: Config.vinedo['estacionMet'] ? true : false
      });


      /*
      mchartEt.agregarSerie({
        color       : Config.colors.et0.background,
        name        : 'Et0',
        yAxis       : 13,
        suffix      : ' mm',
        type        : 'column',
        data        : dataParams.eto,
        labelsData  : dataLabels.eto,
        visibleAxis : true,
        //visible: Config.vinedo['estacionMet'] ? true : false
        visible: false
      });
      */

      chartClima.items.push({
        color       : Config.colors.et0.background,
        name        : 'Et0',
        suffix      : ' mm',
        type        : 'column',
        data        : dataParams.eto,
        labelsData  : dataLabels.eto,
        visible: false
      });




      /*
      mchartEt.agregarSerie({
        color       : Config.colors.etb.background,
        name        : 'Etb',
        yAxis       : 13,
        suffix      : ' mm',
        type        : 'column',
        data        : dataParams.etb,
        labelsData  : dataLabels.etb,
        visibleAxis : true,
        //visible: Config.vinedo['estacionMet'] ? false : true
        visible: false
      });
      */

      chartClima.items.push({
        color       : Config.colors.etb.background,
        name        : 'Etb',
        suffix      : ' mm',
        type        : 'column',
        data        : dataParams.etb,
        labelsData  : dataLabels.etb,
        visible: false
      });






      /*
      mchartEt.agregarSerie({
        color       : Config.colors.et0.background,
        name        : 'Et0 promedio',
        yAxis       : 13,
        suffix      : ' mm',
        type        : 'column',
        data        : dataParams.x_eto,
        labelsData  : dataLabels.x_eto,
        visibleAxis : true,
        //visible: false
        visible: Config.vinedo['estacionMet'] ? true : false
      });
      */

      chartClima.items.push({
        color       : Config.colors.et0.background,
        name        : 'Et0 promedio',
        suffix      : ' mm',
        type        : 'column',
        data        : dataParams.x_eto,
        labelsData  : dataLabels.x_eto,
        visible: Config.vinedo['estacionMet'] ? true : false
      });







      /*
      mchartEt.agregarSerie({
        color       : Config.colors.etb.background,
        name        : 'Etb promedio',
        yAxis       : 13,
        suffix      : ' mm',
        type        : 'column',
        data        : dataParams.x_etb,
        labelsData  : dataLabels.x_etb,
        visibleAxis : true,
        visible: Config.vinedo['estacionMet'] ? false : true
      });
      */

      chartClima.items.push({
        color       : Config.colors.etb.background,
        name        : 'Etb promedio',
        suffix      : ' mm',
        type        : 'column',
        data        : dataParams.x_etb,
        labelsData  : dataLabels.x_etb,
        visible: Config.vinedo['estacionMet'] ? false : true
      });








      /*

      mchartEt.agregarSerie({
        color       : Config.colors.riegoProgramado.background,
        name        : 'Coeficiente',
        yAxis       : 19,
        lineWidth   : 2,
        suffix      : '',
        type        : 'spline',
        data        : dataParams.coeficiente,
        labelsData  : dataLabels.coeficiente,
        visibleAxis : true,
      });
      */

      chartClima.items.push({
        color       : Config.colors.riegoProgramado.background,
        name        : 'Coeficiente',
        type        : 'spline',
        data        : dataParams.coeficiente,
        labelsData  : dataLabels.coeficiente,
        visibleAxis : true,
      });










      
      vm.fechaInicioGradosDia_m = moment(vm.temporadaSelected.inicio, "YYYY-MM-DD").toDate();
      vm.recalcularGradosDias();
      var gdGrafico = vm.getGradosDiasGrafico(datesGradosDia);
      _.each(gdGrafico, function(gd, index){
        var gdLabels = [];
        _.each(gd.labelsData, function(item, index){
          if(index < gd.labelsData.length - 1){
            gdLabels.push("");
          }else{
            gdLabels.push(item);
          }
        });

        /*
        mchartGD.agregarSerie({
          color       : Config.colors.gd.array[index],
          name        : 'Grados dia '+gd.periodo,
          yAxis       : 0,
          lineWidth   : 2,
          suffix      : '',
          type        : 'spline',
          data        : gd.data,
          labelsData  : gdLabels,
          visibleAxis : true,
          visible: index == 0
        });
        */

        chartClima.items.push({
          color       : Config.colors.gd.array[index],
          name        : 'Grados dia '+gd.periodo,
          lineWidth   : 2,
          suffix      : '',
          type        : 'spline',
          data        : gd.data,
          labelsData  : gdLabels,
          visible: index == 0
        });
      });

      //---------------


      vm.fechaInicioGradosDia_m = moment("2017-10-01", "YYYY-MM-DD").toDate();
      vm.recalcularGradosDias("winkler");
      var gdGrafico = vm.getGradosDiasGrafico(datesGradosDia, "winkler");
      _.each(gdGrafico, function(gd, index){
        var gdLabels = [];
        _.each(gd.labelsData, function(item, index){
          if(index < gd.labelsData.length - 1){
            gdLabels.push("");
          }else{
            gdLabels.push(item);
          }
        });

        /*
        mchartGD.agregarSerie({
          color       : Config.colors.winkler.array[index],
          name        : 'winkler '+gd.periodo,
          yAxis       : 0,
          lineWidth   : 2,
          suffix      : '',
          type        : 'spline',
          data        : gd.data,
          labelsData  : gdLabels,
          visibleAxis : true,
          visible: index == 0
        });
        */

        chartClima.items.push({
          color       : Config.colors.winkler.array[index],
          name        : 'winkler '+gd.periodo,
          yAxis       : 0,
          suffix      : '',
          type        : 'spline',
          data        : gd.data,
          labelsData  : gdLabels,
          visible: index == 0
        });
      });





      /*
      mchartVol.agregarSerie({
        color       : Config.colors.volumen.background,
        name        : 'm<sup>3</sup>/ha',
        yAxis       : 7,
        type        : 'column',
        data        : dataParams.volumen_ha,
        labelsData  : dataLabels.volumen_ha,
        suffix      : ' m3/ha',
        required    : true,
        visibleAxis : true
      });
      */

      chartRiego.items.push({
        color       : Config.colors.volumen.background,
        yAxis       : 7,
        name        : 'm<sup>3</sup>/ha',
        type        : 'column',
        data        : dataParams.volumen_ha,
        labelsData  : dataLabels.volumen_ha,
        suffix      : ' m3/ha',
      });

      /*
      mchartVol.agregarSerie({
        color       : Config.colors.volumen.background,
        name        : 'm<sup>3</sup>/ha Acumulada',
        yAxis       : 7,
        type        : 'spline',
        lineWidth   : 2, 
        data        : dataParams.volumen_ha_acum,
        labelsData  : dataLabels.volumen_ha_acum,
        suffix      : ' m3/ha',
        required    : true,
        visibleAxis : true,
        visible: false
      });
      */

      chartRiego.items.push({
        color       : Config.colors.volumen.background,
        yAxis       : 7,
        name        : 'm<sup>3</sup>/ha Acumulada',
        type        : 'spline',
        data        : dataParams.volumen_ha_acum,
        labelsData  : dataLabels.volumen_ha_acum,
        suffix      : ' m3/ha',
        visible: false
      });



      var labelsEtb = concatLabelsData(dataLabels.volumen_ha_teorico_etb, dataLabels.volumen_dif_etb);
      /*
      mchartVol.agregarSerie({
        color       : Config.colors.etb.background,
        name        : 'm<sup>3</sup>/ha teórico etb',
        yAxis       : 7,
        type        : 'column',
        data        : dataParams.volumen_ha_teorico_etb,
        labelsData  : labelsEtb,
        suffix      : ' m3/ha',
        required    : true,
        visibleAxis : true,
        visible: Config.vinedo['estacionMet'] ?  false: true
      });
      */

      chartRiego.items.push({
        color       : Config.colors.etb.background,
        yAxis       : 7,
        name        : 'm<sup>3</sup>/ha teórico etb',
        type        : 'column',
        data        : dataParams.volumen_ha_teorico_etb,
        labelsData  : labelsEtb,
        suffix      : ' m3/ha',
        visible: Config.vinedo['estacionMet'] ?  false: true
      });




      var labelsEto = concatLabelsData(dataLabels.volumen_ha_teorico_eto, dataLabels.volumen_dif_eto);
      /*
      mchartVol.agregarSerie({
        color       : Config.colors.et0.background,
        name        : 'm<sup>3</sup>/ha teórico et0',
        yAxis       : 7,
        type        : 'column',
        data        : dataParams.volumen_ha_teorico_eto,
        labelsData  : labelsEto,
        suffix      : ' m3/ha',
        required    : true,
        visibleAxis : true,
        visible: false
      });
      */

      chartRiego.items.push({
        color       : Config.colors.et0.background,
        yAxis       : 7,
        name        : 'm<sup>3</sup>/ha teórico et0',
        type        : 'column',
        data        : dataParams.volumen_ha_teorico_eto,
        labelsData  : labelsEto,
        suffix      : ' m3/ha',
        visible: false
      });







      /*
      mchartVol.agregarSerie({
        color       : Config.colors.volumen.background,
        name        : 'm<sup>3</sup> total',
        yAxis       : 7,
        type        : 'column',
        data        : dataParams.volumen_total,
        labelsData  : dataLabels.volumen_total,
        suffix      : ' m3',
        required    : true,
        visibleAxis : true,
        visible: false
      });
      */

      chartRiego.items.push({
        color       : Config.colors.volumen.background,
        yAxis       : 7,
        name        : 'm<sup>3</sup> total',
        yAxis       : 7,
        type        : 'column',
        data        : dataParams.volumen_total,
        labelsData  : dataLabels.volumen_total,
        suffix      : ' m3',
        required    : true,
        visibleAxis : true,
        visible: false
      });









      /*
      mchartReposicion.agregarSerie({
        color       : Config.colors.porcentajeIdeal.background,
        name        : 'Reposicion Teórica',
        type        : 'spline',
        yAxis       : 12,
        lineWidth   : 2,
        preffix     : '',
        suffix      : ' %',
        visibleAxis : true,
        data        : dataParams.reposicion_ideal,
        labelsData  : dataLabels.reposicion_ideal,
      });
      */
      
      chartReposicion.items.push({
        color       : Config.colors.porcentajeIdeal.background,
        yAxis       : 12,
        name        : 'Reposicion Teórica',
        type        : 'spline',
        preffix     : '',
        suffix      : ' %',
        data        : dataParams.reposicion_ideal,
        labelsData  : dataLabels.reposicion_ideal,
      });







      
      /*
      mchartReposicion.agregarSerie({
        color       : Config.colors.et0.background,
        name        : 'Reposicion Real ET0',
        type        : 'spline',
        yAxis       : 12,
        lineWidth   : 2,
        preffix     : '',
        suffix      : ' %',
        visibleAxis : true,
        data        : dataParams.reposicion_eto,
        labelsData  : dataLabels.reposicion_eto,
        visible: Config.vinedo['estacionMet'] ? true : false
      });

      */
      
      chartReposicion.items.push({
        color       : Config.colors.et0.background,
        yAxis       : 12,
        name        : 'Reposicion Real ET0',
        type        : 'spline',
        preffix     : '',
        suffix      : ' %',
        data        : dataParams.reposicion_eto,
        labelsData  : dataLabels.reposicion_eto,
        visible: Config.vinedo['estacionMet'] ? true : false
      });







      
      
      /*


      mchartReposicion.agregarSerie({
        color       : Config.colors.etb.background,
        name        : 'Reposicion Real Etb',
        type        : 'spline',
        yAxis       : 12,
        lineWidth   : 2,
        preffix     : '',
        suffix      : ' %',
        visibleAxis : true,
        data        : dataParams.reposicion_etb,
        labelsData  : dataLabels.reposicion_etb,
        visible: Config.vinedo['estacionMet'] ? false : true
      });

      */
      
      chartReposicion.items.push({
        color       : Config.colors.etb.background,
        yAxis       : 12,
        name        : 'Reposicion Real Etb',
        type        : 'spline',
        suffix      : ' %',
        data        : dataParams.reposicion_etb,
        labelsData  : dataLabels.reposicion_etb,
        visible: Config.vinedo['estacionMet'] ? false : true
      });







      
      
      
      /*

      mchartVol.agregarSerie({
        color        : Config.colors.scholander.background,
        name         : 'Bomba Scholander',
        markerSymbol : 'circle',
        type         : "spline",
        radius       : 3,
        yAxis        : 1,
        preffix      : '-',
        suffix       : ' bar',
        visibleAxis  : true,
        oppositeAxis : true,
        labelsData   : dataLabels.scholander,
        data         : dataParams.scholander
      });

      */

      chartRiego.items.push({
        color        : Config.colors.scholander.background,
        yAxis        : 1,
        name         : 'Bomba Scholander',
        //markerSymbol : 'circle',
        type         : "spline",
        //radius       : 3,
        preffix      : '-',
        suffix       : ' bar',
        labelsData   : dataLabels.scholander,
        data         : dataParams.scholander
      });

      
      

      /*
      vm.chart.mchartRiego           = mchartRiego;
      vm.chart.mchartReposicion      = mchartReposicion;
      vm.chart.mchartEt              = mchartEt;
      vm.chart.mchartGD              = mchartGD;
      vm.chart.mchartVol             = mchartVol;
      vm.chart.loadingChart          = false;
      vm.chart.chartConfigRiego      = mchartRiego.getConfig();
      vm.chart.chartConfigReposicion = mchartReposicion.getConfig();
      vm.chart.chartConfigEt         = mchartEt.getConfig();
      vm.chart.chartConfigGD         = mchartGD.getConfig();
      vm.chart.chartConfigVol        = mchartVol.getConfig();
      */

      var datasets = [
        chartRiego,
        chartReposicion,
        //chartCrecimiento,
        chartClima
      ];


      vm.hf = vm.irriviewApi.startIrriChart({
        datasets: datasets,
        //sensores: data.data.sectores[0].sensores,
        callback: function(){
          //vm.loadingChart = false;
        }
      });



    };


    vm.init = function () {
      temporadaFac.getTemporadas().then(function (res) {
        vm.temporadas        = res.data.data;
        vm.temporadaSelected = temporadaFac.getActiva();
        vm.fechaInicioGradosDia_m = moment(vm.temporadaSelected.inicio, "YYYY-MM-DD").toDate();
        var ta1 = temporadaFac.getAnterior(vm.temporadaSelected);
        var ta2 = temporadaFac.getAnterior(ta1);

        var p1Http = {
          vinedo_id: vinedoId,
          periodo: vm.temporadaSelected.periodo
        };
        var p1 = seguimientoRes.gradosDias(p1Http).$promise;


        var p2Http = {
          vinedo_id: vinedoId,
          periodo: ta1.periodo
        };
        var p2 = seguimientoRes.gradosDias(p2Http).$promise;

        var p3Http = {
          vinedo_id: vinedoId,
          periodo: ta2.periodo
        };
        var p3 = seguimientoRes.gradosDias(p3Http).$promise;

        var paramsHttp = [p1Http, p2Http, p3Http];
        var promises = [p1, p2, p3];
        $q.all(promises)
          .then(function(resgd){
            var dataGd = [];

            _.each(resgd, function(gdArray, index){
              dataGd.push({
                data: gdArray.data,
                periodo : paramsHttp[index].periodo
              });
            });

            vm.dataGradosDias = dataGd;
            vm.recalcularGradosDias();
            vm.selectPeriodo(vm.periodoSelected);
        });
      });
    };

    vm.init();


  }
})();
